import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'

import { useAppointmentTypes } from '~/components/common/appointments/useAppointmentTypes'
import { closeSoap } from '~/store/actions/soap'
import { getExpandedIFrame } from '~/store/duck/marketplace'
import { getAwoPmrRightRailEnabled } from '~/store/reducers/constants'

import { useAppointmentCancellationNotification } from '../timetable/useAppointmentCancellationNotification'
import { SoapV2Layout } from './layouts/v2/SoapV2Layout'
import { SoapV3Layout } from './layouts/v3/SoapV3Layout'
import ExpandedMarketplaceIFrame from './marketplace/ExpandedMarketplaceIFrame'
import SoapPageLoader from './SoapPageLoader'
import { useFetchAppointment } from './utils/useFetchAppointment'
import { useInitializeSoap } from './utils/useInitializeSoap'
import { useIsSoapPageLoading } from './utils/useIsSoapPageLoading'
import { useOpenMissingClientPatientMissingFields } from './utils/useOpenMissingClientPatientMissingFields'
import { usePetParentChangeAlert } from './utils/usePetParentChangedAlert'
import { useSoapOrderValidationErrorAlert } from './utils/useSoapOrderValidationErrorAlert'
import { useSoapTemplateTabs } from './utils/useSoapTemplateTabs'

const SoapLayoutWrapper = () => {
  const dispatch = useDispatch()
  const { tabName: urlTabName } = useParams()

  const expandedIFrame = useSelector(getExpandedIFrame)
  const isAwoPmrRightRailEnabled = useSelector(getAwoPmrRightRailEnabled)

  const soapTabs = useSoapTemplateTabs({ redirect: false })
  const isLoading = useIsSoapPageLoading()

  // Responsible to fetch soap and handle initial states and navigation urls
  useInitializeSoap()
  // Whenever another user has changed pet parent we need to display an alert message
  usePetParentChangeAlert()
  // Open missing field dialog whenever there're information missing from patient or client
  useOpenMissingClientPatientMissingFields()
  // Triggered whenever there's some conflict with orders
  useSoapOrderValidationErrorAlert()
  useAppointmentTypes()
  useAppointmentCancellationNotification()
  // Fetch appointment when the page is loaded for forms and reason for visit widgets
  useFetchAppointment()

  // Reset soap to initial state on unmount
  useEffect(
    () => () => {
      dispatch(closeSoap())
    },
    [],
  )

  const currentTab =
    soapTabs?.find((tab) => tab.url === urlTabName) ?? soapTabs?.[0]

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      id="soap-page-content"
      position="relative"
      width="100%"
    >
      <SoapPageLoader open={isLoading || !soapTabs} />
      {expandedIFrame ? (
        <ExpandedMarketplaceIFrame iFrame={expandedIFrame} />
      ) : isAwoPmrRightRailEnabled ? (
        <SoapV3Layout currentTab={currentTab} soapTabs={soapTabs} />
      ) : (
        <SoapV2Layout currentTab={currentTab} soapTabs={soapTabs} />
      )}
    </Box>
  )
}

export default SoapLayoutWrapper
